import { createRef } from "react";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import UpdateProcedureFileApproveSection from "../../../../sections/procedureFileSections/updateProcedureFileApproveSection";
import ApproveNewProcedurePending from "../../createNewProcedureProcess/approveNewProcedurePending";
import styles from "../../style/index.module.scss";
import {
  actions,
  dataStatus,
  fileTags,
  handleRevisionInfoManatoryCheck,
  revisionInfoMandatoryCheck,
  savedInRadioValues,
  proposedChangeTags,
} from "../../../../publicDictionaryValues";
import DetailRevisionInformation from "../../../../sections/procedureFileSections/fields/revisionInformationFields/detailRevisionInformation";
import ProcedureDetailService from "../../../../../service/procedureFile/ProcedureDetailService";

const procedureFileTableRef = createRef();
const reasonRef = createRef();
const noteRef = createRef();
export default class ApproveUpdateProcedurePending extends ApproveNewProcedurePending {
  /**
   * function about return page name
   * @returns
   */
  handleReturnPageName = () => {
    return "Approve Update Procedure";
  };

  /**
   * function about return revision information section
   * @returns
   */
  // @ts-ignore
  handleReturnRevisionInformation = () => {
    const { isDisableAllActionButtons = false } = this.props.pageProps;
    return (
      <ProcedureBlock
        testid="procedure-info-block-arrow"
        className={`${styles.approveProcedureFile} revisionInfoSection`}
        child={
          <DetailRevisionInformation
            title="Revision Information"
            openLoading={this.props._showLoading}
            hideLoading={this.props._hideLoading}
            accountId={this.props.pageProps.procedureAccountID}
            ref={this.props.revisionInfoRef}
            isDisabledAll={isDisableAllActionButtons}
            revisionInfoData={this.props.revisionInfoData}
            updateFileNumLoading={this.props.updateFileNumLoading}
          />
        }
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  /**
   * function about return procedure file section
   * @param {object} obj
   * @returns
   */
  handleReturnProcedureFileSection = (obj: any) => {
    const {
      currentRole,
      isDisableAll,
      isDisableAllActionButtons = false,
      procedureReplaceFileRef,
      isTableBorderError,
    } = obj;
    const {
      data,
      downloadFile,
      isMount,
      savedInProps,
      serverPathProps,
      initSavedInSectionState,
      initServerPathSectionState,
      initProcedureTableData,
      procedureSavedInRef,
      procedureServerPathRef,
      procedureRef,
      levelCRef,
    } = this.props;
    const { CategoryID, AccountID, TaskGroupID, TaskLabelID } = this.props.params;
    return (
      <UpdateProcedureFileApproveSection
        sectionProps={{ currentRole, isDisableAll, isDisableAllActionButtons }}
        refs={{
          procedureSavedInRef: procedureSavedInRef,
          procedureServerPathRef: procedureServerPathRef,
          procedureRef: procedureRef,
          procedureFileTableRef,
          reasonRef,
          noteRef,
          procedureReplaceFileRef,
          levelCRef,
        }}
        data={data}
        isTableBorderError={isTableBorderError}
        downloadFile={downloadFile}
        isMount={isMount}
        savedInProps={savedInProps}
        serverPathProps={serverPathProps}
        initSavedInSectionState={initSavedInSectionState}
        initServerPathSectionState={initServerPathSectionState}
        initProcedureTableData={initProcedureTableData}
        ptParams={{ CategoryID, AccountID, TaskGroupID, TaskLabelID }}
        isLevelCChange={this.props.isLevelCChange}
      />
    );
  };

  // @ts-ignore
  handleApproveSubmitClickCheckRequired = (isRevisonInfoError: any) => {
    const revisionInfo = document.getElementsByClassName("revisionInfoSection")[0];
    if (
      this.props.procedureSavedInRef.current.state.savedInSectionState
        .procedureSaveInCategoryStatusID === null
    ) {
      this.props.procedureSavedInRef.current.setSavedInError();
      this.handleControlErrorScroll(
        this.props.procedureSavedInRef.current.offsetTop + revisionInfo.clientHeight
      );
    }
    if (
      this.props.procedureServerPathRef.current !== null &&
      this.props.procedureServerPathRef.current.state.serverPathSectionState.serverPathStatus ===
        null &&
      this.props.savedInProps.savedInRadioValue !== savedInRadioValues.systemOnly
    ) {
      this.handleCheckServerPathHighLight();
    }
    if (isRevisonInfoError) {
      revisionInfoMandatoryCheck(this.props.revisionInfoRef, revisionInfo);
      // @ts-ignore
      this.handleControlErrorScroll(revisionInfo.offsetTop);
    }
  };

  /* function about click submit button in approve page */
  handleApproveSubmitClickCheck = (procedureFileData: any, tableErrorList: any) => {
    let isTableError = false;
    const isRevisonInfoError = handleRevisionInfoManatoryCheck(this.props.revisionInfoRef);
    const errorIndexList: any[] = [];
    procedureFileData.forEach((fileData: any, index: any) => {
      const statusData = fileData.data.find((item: any) => item.name === "status");
      if (
        statusData.value === null &&
        fileData.data.find((item: any) => item.name === "fileName").tagValue !== null
      ) {
        procedureFileData[index].isError = true;
        isTableError = true;
        errorIndexList.push(index);
        // @ts-ignore
        procedureFileTableRef.current.updateDataList(procedureFileData);
        tableErrorList.push(statusData);
      }
    });
    if (
      this.props.procedureSavedInRef.current.state.savedInSectionState
        .procedureSaveInCategoryStatusID === null ||
      (this.props.savedInProps.savedInRadioValue !== savedInRadioValues.systemOnly &&
        this.props.savedInProps.savedInRadioValue !== null &&
        this.props.procedureServerPathRef.current !== null &&
        this.props.procedureServerPathRef.current.state.serverPathSectionState.serverPathStatus ===
          null) ||
      isRevisonInfoError
    ) {
      this.handleApproveSubmitClickCheckRequired(isRevisonInfoError);
    } else if (
      (this.props.savedInProps.savedInRadioValue === savedInRadioValues.systemOnly ||
        this.props.savedInProps.savedInRadioValue === savedInRadioValues.systemAndClientServer) &&
      isTableError
    ) {
      const firstErrorTr = document.getElementById(`table-tr-${errorIndexList[0]}`);
      // @ts-ignore
      this.handleControlErrorScroll(firstErrorTr.offsetTop + firstErrorTr.clientHeight);
    } else {
      // @ts-ignore
      this.handleCreateActionClickSectionCheckModal(
        "",
        this.modalContentLabels.submitConfirmModalLabel,
        this.handleSubmitOkClick,
        this.hideModal
      );
    }
  };

  /* function about click submit or save button to trigger api */
  createProcedureFileTriggerAction = () => {
    // @ts-ignore
    ProcedureDetailService.updateProcedureTriggerApprovePageAction(
      this.para,
      this._triggerSuccess,
      this._triggerError
    );
  };

  /**
   * function about return submit data for api
   * @param {string} actionName
   * @param {boolean} isReturn
   */
  handleReturnSubmitPara = (actionName: any, isReturn: any) => {
    if (actionName === "Reject") {
      // @ts-ignore
      this.para = this.props.handleReturnSubmitData({
        actionID: actions.reject,
        actionName: "Reject",
        procedureSavedInRef: this.props.procedureSavedInRef,
        procedureServerPathRef: this.props.procedureServerPathRef,
        pageProcedureRef: this.props.procedureRef,
        approvePageRef: this.props.approvePageRef,
        revisionInfoRef: this.props.revisionInfoRef,
        isLevelCChangeValue: false,
        levelCRef: this.props.levelCRef,
      });
    } else {
      if (isReturn) {
        // @ts-ignore
        this.para = this.props.handleReturnSubmitData({
          actionID: actions.return,
          actionName: "Return",
          procedureSavedInRef: this.props.procedureSavedInRef,
          procedureServerPathRef: this.props.procedureServerPathRef,
          pageProcedureRef: this.props.procedureRef,
          approvePageRef: this.props.approvePageRef,
          revisionInfoRef: this.props.revisionInfoRef,
          isLevelCChangeValue: false,
          levelCRef: this.props.levelCRef,
        });
      } else {
        // @ts-ignore
        this.para = this.props.handleReturnSubmitData({
          actionID: actions.approve,
          actionName: "Approve",
          procedureSavedInRef: this.props.procedureSavedInRef,
          procedureServerPathRef: this.props.procedureServerPathRef,
          pageProcedureRef: this.props.procedureRef,
          approvePageRef: this.props.approvePageRef,
          revisionInfoRef: this.props.revisionInfoRef,
          isLevelCChangeValue: false,
          levelCRef: this.props.levelCRef,
        });
      }
    }
  };

  /**
   * delete revision information before submit or reject
   * @param {string} actionName
   * @param {boolean} isReturn
   */
  handleRejectOrSubmitClickAdjustDeleteFile = (actionName: any, isReturn: any) => {
    const deleteIds = this.props.revisionInfoRef.current.state.deleteIds;
    const revisionAttachments = this.props.revisionInfoRef.current.state.currentAttachment.filter(
      (item: any) => !deleteIds.includes(item?.fileId)
    );
    this.props.revisionInfoRef.current.state.currentAttachment = revisionAttachments;

    this.handleReturnSubmitPara(actionName, isReturn);
    this.createProcedureFileTriggerAction();
  };

  /* function about click submit button in submit modal */
  handleSubmitOkClick = () => {
    const { data } = this.props;
    const dataList = data.map((item: any) => item.data);
    this.setState({
      pageState: {
        ...this.state.pageState,
        isSubmitDisabled: true,
      },
    });
    this.props._showLoading();
    this.hideModal();
    const isTableDataReturn = this.CheckIsTableDataReturn(dataList);
    const isSavedInReturn =
      this.props.procedureSavedInRef.current.state.savedInSectionState
        .procedureSaveInCategoryStatusID === dataStatus.return;
    const isServerPathReturn =
      this.props.savedInProps.savedInRadioValue !== savedInRadioValues.systemOnly &&
      this.props.procedureServerPathRef.current !== null &&
      this.props.procedureServerPathRef.current.state.serverPathSectionState.serverPathStatus ===
        dataStatus.return;
    const isReturn = isTableDataReturn || isSavedInReturn || isServerPathReturn;
    if (isTableDataReturn || isSavedInReturn || isServerPathReturn) {
      this.handleRejectOrSubmitClickAdjustDeleteFile("Return", isReturn);
    } else {
      this.handleRejectOrSubmitClickAdjustDeleteFile("Approve", isReturn);
    }
  };

  CheckIsTableDataReturn = (dataList: any) => {
    let isTableDataReturn = false;
    /// If saved in is server only or null, no need to check table data
    if (
      this.props.savedInProps.savedInRadioValue === null ||
      this.props.savedInProps.savedInRadioValue === savedInRadioValues.serverOnly
    ) {
      return isTableDataReturn;
    }

    const fileList =
      this.props.procedureRef.current === null ? [] : this.props.procedureRef.current.getDataList();
    try {
      fileList.forEach((fileData: any, index: any) => {
        const statusData = fileData.data.find((item: any) => item.name === "status");
        const file = fileData.data.find((item: any) => item.name === "fileName");
        const dataItem = dataList.find((item: any) => {
          const fileName = item.find((e: any) => e.name === "fileName").value;
          return fileName === file.value;
        });
        const proposedChange = dataItem.find((item: any) => item.name === "proposedChange").value;
        isTableDataReturn =
          statusData.value === dataStatus.return &&
          !(file.tagValue === fileTags.deleted && proposedChange === proposedChangeTags.new);
        if (isTableDataReturn) {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }

    return isTableDataReturn;
  };

  /* function about click submit button in reject modal */
  handleRejectOkClick = () => {
    const rejectReasonValue = this.state.pageState.rejectReason;
    const reason = rejectReasonValue !== null ? rejectReasonValue.trim() : rejectReasonValue;
    if (reason === null || reason === "") {
      this.setState({
        pageState: { ...this.state.pageState, rejectStatus: "error" },
      });
    } else {
      this.setState({
        pageState: {
          ...this.state.pageState,
          rejectStatus: null,
          isRejectDisabled: true,
        },
      });
      this.props._showLoading();
      this.hideModal();
      this.handleRejectOrSubmitClickAdjustDeleteFile("Reject", false);
    }
  };
}
